import React from 'react';
import { StyleSheet, View, Platform } from 'react-native';
import { scale } from '../../utils/scale.utils';
import { FontSize, CommonProperties, CommonStyles as CS, Color } from '../../styles';
import BaseText from '../BaseText';

const getBottom = (size, platform) => {
  switch (platform) {
    case 'web':
      return (size - size * 0.92) * -1;
    default:
      // FIXME: Check if this value works for iOS
      return (size - size * 0.72) * -1;
  }
};

export const cardStyle = StyleSheet.create({
  composedRow: {
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    ...CommonProperties.flex1,
    ...CommonProperties.row,
    ...CommonProperties.p3,
  },
  composed: {
    ...CommonProperties.flex1,
    ...CommonProperties.p3,
  },
  large: {
    fontSize: FontSize.h1,
    textAlignVertical: 'top',
    lineHeight: FontSize.h1,
    paddingTop: FontSize.h1 - FontSize.h1 * 0.92,
    marginBottom: getBottom(FontSize.h1, Platform.OS),
  },
  medium: {
    paddingTop: 2,
    fontSize: FontSize.h3,
    lineHeight: FontSize.h3,
  },
  titleExtra: {
    color: Color.primary,
    textAlignVertical: 'bottom',
    ...CommonProperties.ml2,
    ...CommonProperties.small,
  },
  grayColor: {
    color: Color.gray,
  },
  textRow: {
    ...CommonProperties.row,
    ...CommonProperties.wrap,
  },
  rating: {
    height: scale(12),
    width: scale(70),
    resizeMode: 'contain',
  },
  disabled: {
    opacity: 0.5,
  },
});

export const getStringRating = (number) => (number ? (number < 10 ? number * 10 : number) : '00');

export const XSmallText = ({ style, ...rest }) => <BaseText style={[CS.xSmall, style]} {...rest} />;

export const CardLeftTextDetail = ({ style, children, ...rest }) => {
  return (
    <View style={[styles.leftTextBox, style]} {...rest}>
      <XSmallText>{children}</XSmallText>
    </View>
  );
};

export const ShrinkView = ({ style, ...rest }) => {
  return <View style={[CS.shrink, style]} {...rest} />;
};

export const ReceiptFooter = ({ item = {} }) => {
  return (
    <>
      <BaseText style={CS.small}>
        {item?.registeredAs}:{' '}
        {item.passengers.map((passenger) => {
          return passenger.FirstName;
        })}{' '}
      </BaseText>
      <BaseText style={CS.small}>Confirmation #: {item.confirmation} </BaseText>
    </>
  );
};

export const ReceiptCheckinBlock = ({ item = {} }) => {
  return (
    <View style={CS.center}>
      <XSmallText style={cardStyle.grayColor}>{item.fromText}</XSmallText>
      <XSmallText>{item.startDate}</XSmallText>
      <XSmallText style={cardStyle.grayColor}>{item.toText}</XSmallText>
      <XSmallText>{item.endDate}</XSmallText>
    </View>
  );
};

export const PerUnitPrice = ({ label, value }) => {
  return (
    <View style={styles.perUnitPrice}>
      <BaseText style={CS.small}>{label}</BaseText>
      <BaseText style={CS.h3}>{value}</BaseText>
    </View>
  );
};

const styles = StyleSheet.create({
  leftTextBox: {
    width: scale(72 * 0.8),
    alignItems: 'flex-end',
    ...CommonProperties.pr2,
  },
  perUnitPrice: {
    backgroundColor: Color.disabled,
    alignItems: 'center',
    ...CommonProperties.px4,
    ...CommonProperties.py2,
    ...CommonProperties.borderRadius1,
  },
});
